import { NotImplementedError } from "../../../../errors";
import { lookerInventoryModelFieldsToQueryDimensions, lookerInventoryQueryDimensionsToModel, modelFiltersToQueryFilters } from "../../../../models/looker/modules/inventory";
import { PromiseHandler } from "../../../../handlers";
import Advertiser from "./filters/Advertiser";
import Publisher from "./filters/Publisher";
import Campaign from "./filters/Campaign";
import Bundle from "./filters/Bundle";
import Channel from "./filters/Channel";
import ProductType from "./filters/ProductType";
import { INVENTORY_QUERY } from "./query";
class LookerInventory extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-inventory");
        this.filters = {
            advertiser: new Advertiser(sdk),
            publisher: new Publisher(sdk),
            campaign: new Campaign(sdk),
            bundle: new Bundle(sdk),
            channel: new Channel(sdk),
            productType: new ProductType(sdk)
        };
    }
    async findItems(filters) {
        const fields = lookerInventoryModelFieldsToQueryDimensions(filters.fields || []);
        if (fields.length === 0) {
            throw new Error("You must specify at least one field to query");
        }
        // Enforce minimum date for product type queries
        this.enforceMinDateForProductType(filters);
        const queryFilters = modelFiltersToQueryFilters(filters);
        const sortKey = fields.find((field) => field === "delivery_billable_base.delivered_impressions") || fields[0];
        // default to sort by impressions
        const sorts = [`${sortKey} desc`];
        const queryBody = {
            ...INVENTORY_QUERY,
            filters: queryFilters,
            fields: fields,
            sorts
        };
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: data.map((inventory) => lookerInventoryQueryDimensionsToModel(filters.fields || [], inventory)),
                queryMeta
            }
        ])
            .catch(() => {
            throw new Error("Failed to fetch inventory data");
        }));
    }
    enforceMinDateForProductType(filters) {
        // Check if productType is in the fields array
        if (filters.fields?.includes("productType")) {
            // Find the date filter
            const dateFilter = filters.where?.find((filter) => filter.field === "dates");
            if (dateFilter && Array.isArray(dateFilter.value) && dateFilter.value.length >= 1) {
                const startDate = dateFilter.value[0];
                if (startDate instanceof Date) {
                    // Minimum allowed date for product type queries (July 1, 2025)
                    const minDate = new Date(2025, 6, 1); // Month is 0-indexed
                    if (startDate < minDate) {
                        throw new Error("Product type queries cannot have a start date before July 1, 2025");
                    }
                }
            }
        }
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
export default LookerInventory;
//# sourceMappingURL=index.js.map